{
  "processing": "ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਪ੍ਰਕਿਰਿਆ ਜਾਰੀ ਹੈ...",
  "loadingIframe": "ID ਪੁਸ਼ਟੀਕਰਨ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
  "issueTitle": "ID ਪੁਸ਼ਟੀਕਰਨ ਸਮੱਸਿਆ",
  "notConfigured": "ਇਸ ਗੁਦਾਮ ਲਈ ID ਪੁਸ਼ਟੀਕਰਨ ਸਹੀ ਢੰਗ ਨਾਲ ਸੰਰਚਿਤ ਨਹੀਂ ਹੈ।",
  "notSuccessful": "ID ਪੁਸ਼ਟੀਕਰਨ ਸਫਲ ਨਹੀਂ ਹੋਇਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਗੁਦਾਮ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
  "couldNotCompleteProceed": "ID ਪੁਸ਼ਟੀਕਰਨ ਪੂਰਾ ਨਹੀਂ ਹੋ ਸਕਿਆ, ਪਰ ਤੁਸੀਂ ਚੈੱਕ-ਇਨ ਨਾਲ ਅੱਗੇ ਵਧ ਸਕਦੇ ਹੋ।",
  "processFailed": "ID ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਪ੍ਰਕਿਰਿਆ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  "processingFailedProceed": "ID ਪੁਸ਼ਟੀਕਰਨ ਦੀ ਪ੍ਰਕਿਰਿਆ ਅਸਫਲ ਹੋਈ, ਪਰ ਤੁਸੀਂ ਚੈੱਕ-ਇਨ ਨਾਲ ਅੱਗੇ ਵਧ ਸਕਦੇ ਹੋ।",
  "genericError": "ID ਪੁਸ਼ਟੀਕਰਨ ਦੌਰਾਨ ਇੱਕ ਗਲਤੀ ਹੋਈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  "issueProceed": "ID ਪੁਸ਼ਟੀਕਰਨ ਵਿੱਚ ਇੱਕ ਸਮੱਸਿਆ ਆਈ, ਪਰ ਤੁਸੀਂ ਚੈੱਕ-ਇਨ ਨਾਲ ਅੱਗੇ ਵਧ ਸਕਦੇ ਹੋ।",
  "requiredTryAgain": "ਚੈੱਕ-ਇਨ ਪੂਰਾ ਕਰਨ ਲਈ ID ਪੁਸ਼ਟੀਕਰਨ ਜ਼ਰੂਰੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  "checkInFailedTitle": "ਚੈੱਕ-ਇਨ ਨਹੀਂ ਹੋ ਸਕਿਆ",
  "checkInFailedMessage": "ਤੁਹਾਡੀ ID ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ"
}
